module.exports = __webpack_public_path__ + "img/bg.9e0637db.png";